module.exports = __webpack_public_path__ + "static/media/4_DSC_7227.1c43820c.webp";